// extracted by mini-css-extract-plugin
module.exports = {"layers":"_2QqtVOP1seoKBbG14vyF0z","marketplaceToolAndArea":"_2SXswEY8EnUTfC097mEVr-"};